import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { CommonErrorMessages, LoginDevicesErrorMessages } from '../../constants/error-messages';
import { LoginLabelConstants } from '../../constants/label-constants';
import { verificationCodeModel } from '../../models/authentication/login-model';
import { StateService } from '../../services/common/claim-year.service';
import { CommonService } from '../../services/common/common.service';
import { StorageService } from '../../services/storage/storage.service';
import { UserService } from '../../services/user-service/user.service';
import { SharedService } from '../../services/shared-service/shared.service';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  styleUrl: './verification-code.component.scss'
})
export class VerificationCodeComponent {

  verificationForm: FormGroup | any;
  submitted: boolean = false;
  labelConstants: any;
  errorConstants: any;
  isLoading: boolean = false;
  emailAddress : string = "";
  currentYear: number = new Date().getFullYear();;
  otp: any;
  isTimerRunning: boolean = false;
  isResendDisabled: boolean = true;
  countDown!: Subscription;
  private subscription: Subscription = new Subscription();
  counter = 301;
  tick = 1000;
  isDisabled: boolean = true;
  isCounterShow: boolean = true;
  interval: any;
  minutes: any = 5;
  seconds: any = 0;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  @Input() verificationResponse!: any;
  @Output() viewVerificationCode = new EventEmitter<boolean>();
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
  };


  constructor(
    private readonly fb: FormBuilder,
    private readonly spinner: NgxSpinnerService,
    private readonly toastr: ToastrService,
    private readonly commonService: CommonService,
    private readonly router: Router,
    private readonly api: ApiUrlHelper,
    private readonly storageService: StorageService,
    private readonly sharedService: SharedService,
    private readonly sharedDataService: StateService,
    private readonly userService: UserService,

  ) {}

  ngOnInit(): void {
    this.emailAddress = this.verificationResponse.EmailId
    this.sharedService.setData('Two-Factor Verification');
    this.labelConstants = LoginLabelConstants;
    this.errorConstants = LoginDevicesErrorMessages;

    this.verificationForm = this.fb.group({
      verificationCode: [
        '', [Validators.required],
      ],
      isLoginProtection: [false]
    });

    if (localStorage.getItem('authToken')) {
      this.router.navigate(['/dashboard']);
    }

    this.isResendDisabled = true; // Disable the resend link initially
    this.loadTimer(); // Start loading the timer
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  get verificationFormControls() {
    return this.verificationForm?.controls;
  }

  onOtpChange(event: any) {
    this.otp = event;
  }

  verifyCode() {
    this.submitted = true;
    let locationDetails: any = {};

    // Get Current location details
    this.commonService.getLocationDetails().pipe().subscribe({
      next: (response) => {
        locationDetails = { ...response }
        this.getLoginInfo(locationDetails);
      },
      error: (err) => {
        this.getLoginInfo(locationDetails);
      },
    });
  }

  getLoginInfo(locationDetails: any) {
    if(this.otp == null || this.otp == undefined || this.otp == ''){
      this.submitted = false;
      this.toastr.error(this.errorConstants.OtpReqired);
      return
    }
    let obj = {
      cityName: locationDetails?.city,
      stateName: locationDetails?.region,
      countryName: locationDetails?.country_name,
      postalCode: locationDetails?.postal,
      countryCapital: locationDetails?.country_capital,
      iPAddress: locationDetails?.ip,
      iPVersion: locationDetails?.version,
      network: locationDetails?.network,
      org: locationDetails?.org,
      isLoginProtection: this.verificationForm.value.isLoginProtection,
      otp: this.otp,
      password: this.verificationResponse.Password,
      emailId: this.verificationResponse.EmailId,
      encryptedOtp: this.verificationResponse.EncryptedOtp
    }
    const apiUrl = this.api.apiUrl.Login.VerifyOTP;
    this.spinner.show();
    this.commonService.doPost(apiUrl, obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.router.navigate(['dashboard']);
          let EncryptUserId = this.commonService.Encrypt(response.data.userId)
          let EncryptRoleId = this.commonService.Encrypt(response.data.roleId)
          let LoginTokenId = this.commonService.Encrypt(response.data.loginTokenId)
          this.storageService.setValue('authToken', response.data.jwtToken);
          this.storageService.setValue('userId', EncryptUserId);
          this.storageService.setValue('loginTokenId', LoginTokenId);
          this.storageService.setValue('userRole', response.data.roleName);
          this.storageService.setValue('userName', response.data.fullName);
          this.storageService.setValue('roleId', EncryptRoleId);
          this.storageService.setValue('userImage', response.data.photo);
          this.storageService.setValue('companyName', response.data.companyName);
          this.commonService.setUserImage(response.data.photo);
          this.userService.setUserName(response.data.fullName);

          this.storageService.setValue(
            'companyId',
            response.data.roleId === 1 ? null : response.data.companyId
          );
          if (response.data.roleId != 1) {
            this.sharedDataService.setCompanyId(response.data.companyId.toString())
            this.sharedDataService.setYearId('')
          }
        }
        else {
          this.setLoadingState(false);
          this.toastr.error(response.message);
          this.submitted = false;
          }
        this.spinner.hide();
      },
      error: (err) => {
        this.setLoadingState(false);
        this.spinner.hide();
        this.submitted = false;
      },
    });
  }

  ResendOTP() {
    if (!this.isResendDisabled) {
      // Call your API to resend OTP here
      this.isResendDisabled = true; // Disable resend link again after clicking
      this.startTimer(); // Restart the timer after resend
      this.loadTimer(); // Restart the timer logic
    }
    this.spinner.show();
    this.loadTimer();
    let locationDetails: any = {};
    this.otp = '';
    this.ngOtpInput.setValue('');
    // Get Current location details
    this.commonService.getLocationDetails().pipe().subscribe({
      next: (response) => {
        locationDetails = { ...response }
      },
      error: (err) => {
      },
    });
    let apiUrl = this.api.apiUrl.Login.UserLogin;
    localStorage.clear();
    var obj = {
      emailId: this.verificationResponse.EmailId,
      password: this.verificationResponse.Password
    }
    this.commonService.doPost(apiUrl, obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.verificationResponse.EncryptedOtp = response.data;
          this.submitted = false;
          this.setLoadingState(false);
          this.spinner.hide();
          this.setLoadingState(false);
        } else {
          this.setLoadingState(false);
          this.spinner.hide();
          this.toastr.error(response.message);
        }
      },
      error: (err) => {
        this.setLoadingState(false);
        this.spinner.hide();
      },
    });
  }

  setLoadingState(isLoading: boolean) {
    this.isLoading = isLoading;
    if (isLoading) {
      this.verificationForm.disable();
    } else {
      this.verificationForm.enable();
    }
  }

  loadTimer() {
    const storedEndTime = localStorage.getItem('otpEndTime');
    if (storedEndTime) {
      const endTime = new Date(storedEndTime).getTime();
      const currentTime = new Date().getTime();
      const remainingTime = Math.floor((endTime - currentTime) / 1000);
      if (remainingTime > 0) {
        this.counter = remainingTime;
        this.startTimer();
      } else {
        this.handleTimerEnd();
      }
    } else {
      this.resetTimer();
    }
  }

  saveTimer() {
    const endTime = new Date().getTime() + this.counter * 1000;
    localStorage.setItem('otpEndTime', new Date(endTime).toISOString());
  }

  resetTimer() {
    this.counter = 301;
    this.saveTimer();
    this.startTimer();
  }

  startTimer() {
    this.subscription?.unsubscribe();
    this.subscription = interval(1000).subscribe(() => {
      if (this.counter === 0) {
        this.handleTimerEnd();
        this.subscription?.unsubscribe();
      } else {
        this.counter--;
        this.minutes = Math.floor(this.counter / 60).toString().padStart(2, '0');
        this.seconds = (this.counter % 60).toString().padStart(2, '0');
        this.saveTimer();
      }
    });
  }

  handleTimerEnd() {
    this.subscription.unsubscribe();
    this.verificationForm.disable();
    this.submitted = true;
    this.isResendDisabled = false;
    localStorage.removeItem('otpEndTime');
  }

  goLogin() {
    this.viewVerificationCode.emit(false);
  }
}
